export default "__VITE_ASSET__B85UUO36__"